import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Shell } from "@/components/Shell";
import { WeightsEditor } from "@/components/WeightsEditor";
import { loadWeights, saveWeights } from "@/lib/storage";

export default function WeightsPage() {
  const navigate = useNavigate();
  const [weights, setWeights] = useState(loadWeights);
  const update = (w) => {
    saveWeights(w);
    setWeights(w);
  };
  return (
    <Shell wide header={<button className="btn btn-ghost !min-h-[44px] text-sm" onClick={() => navigate("/")} data-testid="weights-back-btn"><ArrowLeft size={16} /> Elenco</button>}>
      <div className="fade-up">
        <WeightsEditor weights={weights} onChange={update} />
      </div>
    </Shell>
  );
}
